import { render, staticRenderFns } from "./TopEntityComponentLanguages.vue?vue&type=template&id=3658b295&"
import script from "./TopEntityComponentLanguages.vue?vue&type=script&lang=js&"
export * from "./TopEntityComponentLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports